import "../../App.css";
import { useAuthUser, useIsAuthenticated } from "react-auth-kit";
import Telemonitoraggi from "../telemonitoraggi/Telemonitoraggi";
import Counters from "../../components/Counters/Counters";
import ControlRoom from "../controlroom/ControlRoom";
import MonitorAlert from "../monitoralert/MonitorAlert";
import PageTitle from "../../components/PageTitle/PageTitle";
import DailyReports from "../dailyreports/DailyReports";

function Dashboard() {
  const authUser = useAuthUser();
  const isAuthenticated = useIsAuthenticated();

  return (
    <main style={{ width: "100%" }}>
      {isAuthenticated() &&
        authUser() !== null &&
        (authUser()?.role === 3 ? (
          <MonitorAlert />
        ) : authUser()?.role === 2 ? (
          <DailyReports />
        ) : (
          <>
            <PageTitle title="Counters" />
            <Counters />
          </>
        ))}
    </main>
  );
}

export default Dashboard;
